import { render, staticRenderFns } from "./BaseRadio.vue?vue&type=template&id=da098d14&scoped=true"
import script from "./BaseRadio.vue?vue&type=script&lang=ts"
export * from "./BaseRadio.vue?vue&type=script&lang=ts"
import style0 from "./BaseRadio.vue?vue&type=style&index=0&id=da098d14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da098d14",
  null
  
)

export default component.exports